import { useState } from "react";
import { toast } from "react-toastify";
import { post } from "../networking/RequestService";
import useGetProfile from "./useGetProfile";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useSetProfileKeyContact = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { profile } = useExtensionContext();
    const { refetch: getProfile } = useGetProfile();

    const setProfileKeyContact = async (option, status = null) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "setProfileKeyContact",
                profileId: profile?.id,
                option: option,
                status: status,
            };

            const response = await post(payload);
            if (response.data.stat === "nok") {
                toast.warning(response?.data?.text);
            } else if (response.data.stat === "ok") {
                // toast.success(response?.data?.text);
                await getProfile();
                return { data: response.data };
            }
        } catch (err) {
            const errorMessage = apiErrorText(err);

            setError(errorMessage);
            toast.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return {
        setProfileKeyContact,
        loading,
        error,
    };
};

export default useSetProfileKeyContact;
